import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import { upperFirst, camelCase } from 'lodash';

var requireComponents = require.context('src/components', true, /(Dialogs)\/[A-Z]\w+\.(vue|js)$/);

requireComponents.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponents(fileName); // Get PascalCase name of component

  var componentName = componentConfig.default.name || upperFirst(camelCase( // Gets the file name regardless of folder depth
  fileName.split('/').pop().replace(/\.\w+$/, ''))); // Register component globally

  Vue.component(componentName, componentConfig.default || componentConfig);
});
export default (function (_ref) {
  var app = _ref.app,
      router = _ref.router,
      store = _ref.store,
      Vue = _ref.Vue;
  Vue.mixin({
    methods: {
      openDialog: function openDialog(dialogName, props, scope) {
        this.$q.dialog(_objectSpread(_objectSpread({
          component: "".concat(dialogName)
        }, props), {}, {
          parent: scope || this
        }));
      }
    }
  });
});